import {
  PROJECT_DEVICES_FETCH_STARTED,
  PROJECT_DEVICES_FETCH_SUCCEEDED,
  PROJECT_DEVICES_FETCH_FAILED,
  PROJECT_DEVICES_CHANGE_PAGE,
  PROJECT_DEVICES_CHANGE_ITEMS_PER_PAGE,
  PROJECT_DEVICES_CHANGE_ORDER,
  PROJECT_DEVICES_CHANGE_ORDER_BY,
  PROJECT_DEVICES_CHANGE_ORDER_AND_ORDER_BY,
  PROJECT_DEVICES_SET_FILTER,
  PROJECT_DEVICES_SET_DEVICE_TYPE,
  OPEN_PROJECT_DEVICES_POPUP,
  PROJECT_DEVICES_POPUP_SET_ADD_MODE,
  PROJECT_DEVICES_SET_FORM_DEVICES,
  PROJECT_DEVICES_POPUP_SET_REMOVED_DEVICES,
  PROJECT_DEVICES_POPUP_SET_ADDED_DEVICES,
  PROJECT_DEVICES_POPUP_SET_STATE_CHANGED,
  PROJECT_DEVICES_POPUP_SET_STATE_DIFF,
  PROJECT_DEVICES_POPUP_PROJECT_FETCH_SUCCEEDED,
  PROJECT_DEVICES_CLEAR,
  PROJECT_DEVICES_POPUP_TOGGLE_DEVICE_ALERT,
  PROJECT_DEVICES_POPUP_SET_DEVICE_ALERT,
  PROJECT_DEVICES_POPUP_TOGGLE_ALL_DEVICES_ALERT
} from '#action/types';
import { mapDevicesToPopup } from '#component/device/devices-popup/helper';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  devices: [],
  formDevices: [],
  addedDevices: [],
  project: null,
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'desc',
  orderBy: 'title',
  pages: 0,
  filter: null,
  filterBy: 'title',
  deviceType: null,
  isOpen: false,
  addMode: false,
  removedDevices: [],
  newlyAddedDevices: [],
  isPopupStateChanged: false,
  stateDiff: [],
  devicesWithAlerts: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case PROJECT_DEVICES_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case PROJECT_DEVICES_FETCH_SUCCEEDED:
      const { alertId, formDevices } = action.payload;
      const devicesWithAdditionalInfo =
        mapDevicesToPopup(action.payload.devices, alertId, formDevices);

      return {
        ...state,
        status: statuses.succeeded,
        devices: devicesWithAdditionalInfo,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case PROJECT_DEVICES_SET_FORM_DEVICES:
      return {
        ...state,
        // status: statuses.succeeded,
        formDevices: action.payload.formDevices,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case PROJECT_DEVICES_POPUP_SET_DEVICE_ALERT: {
      const getData = newDevice => {
        const selectedAlert = state.devicesWithAlerts;
        const selectedIndex = selectedAlert.map(s => s.id).indexOf(newDevice.id);
        let newSelected = [];

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selectedAlert, newDevice);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selectedAlert.slice(1));
        } else if (selectedIndex === selectedAlert.length - 1) {
          newSelected = newSelected.concat(selectedAlert.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selectedAlert.slice(0, selectedIndex),
            selectedAlert.slice(selectedIndex + 1)
          );
        }

        return newSelected;
      };

      const data = getData(action.payload);

      return {
        ...state,
        devicesWithAlerts: data
      };
    }
    case PROJECT_DEVICES_POPUP_TOGGLE_DEVICE_ALERT: {
      const { device } = action.payload;
      const updatedDevices = state.devices.map(d => {
        if (d.id === device.id) {
          return {
            ...d,
            alertOn: !!device.alertOn
          };
        }

        return d;
      });

      return {
        ...state,
        devices: updatedDevices,
        devicesWithAlerts: state.devicesWithAlerts.filter(d => d.id !== device.id)
      };
    }
    case PROJECT_DEVICES_POPUP_TOGGLE_ALL_DEVICES_ALERT: {
      const { toggleState } = action.payload;
      const updatedDevices = state.devices.map(d => ({
        ...d,
        alertOn: toggleState
      }));

      return {
        ...state,
        devices: updatedDevices,
        devicesWithAlerts: updatedDevices
      };
    }
    case PROJECT_DEVICES_POPUP_SET_REMOVED_DEVICES:
      return { ...state, removedDevices: action.payload };
    case PROJECT_DEVICES_POPUP_SET_ADDED_DEVICES:
      return { ...state, newlyAddedDevices: action.payload };
    case PROJECT_DEVICES_FETCH_FAILED:
      return { ...state, status: statuses.failed, devices: [], error: action.error };
    case PROJECT_DEVICES_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case PROJECT_DEVICES_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case PROJECT_DEVICES_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case PROJECT_DEVICES_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case PROJECT_DEVICES_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case PROJECT_DEVICES_SET_FILTER:
      return { ...state, filter: action.payload };
    case PROJECT_DEVICES_SET_DEVICE_TYPE:
      return { ...state, deviceType: action.payload };
    case OPEN_PROJECT_DEVICES_POPUP: {
      if (typeof action.payload !== 'boolean') { // Multiple forms
        return { ...state, ...action.payload };
      }
      return { ...state, isOpen: action.payload };
    }
    case PROJECT_DEVICES_POPUP_SET_ADD_MODE:
      return { ...state, addMode: action.payload };
    case PROJECT_DEVICES_POPUP_SET_STATE_CHANGED:
      return { ...state, isPopupStateChanged: action.payload };
    case PROJECT_DEVICES_POPUP_SET_STATE_DIFF:
      return { ...state, stateDiff: action.payload };
    case PROJECT_DEVICES_POPUP_PROJECT_FETCH_SUCCEEDED:
      return { ...state, project: action.payload };
    case PROJECT_DEVICES_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
